<script>
  import { onMount } from "svelte";
  import { createEventDispatcher } from "svelte";
  import { makeWebsiteRequest, resource } from "../Common/tools";
  import {External, M} from "../external";

  const dispatch = createEventDispatcher();

  let settings = null;
  let changed = false;

  let setChanged = (isChanged) => {
    changed = isChanged;
    External.CPanel.setChanged(isChanged !== false);
  };

  let discardChanges = () => {
    setChanged(false);
    External.CPanel.goToUrl("/me/store/styling", true);
  };
  let save = async () => {
    let result = await makeWebsiteRequest({
      action: "saveStoreGeneralSettings",
      data: {
        settings: JSON.stringify(settings.general)
      }
    });

    External.Website.setCurrencySymbols(settings.general.currency, settings.general.currencySymbol, settings.general.currencyPosition === 0);
    External.Website.storeWeightUnit = settings.general.weightUnit;
    External.Website.storeDimensionsUnit = settings.general.dimensionsUnit;
    External.Website.storeProcess = settings.general.storeProcess;
    window.cartIconTypeInHeader = settings.general.cartLinkType;
    setChanged(false);
    External.Tools.showAutohideMessage(1000, M.UPDATED);
  };

  onMount(async () => {
    let result = await makeWebsiteRequest({
      action: "getStoreSettings"
    });
    settings = result.data;
    // most of these settings are NOT edited anymore. Use the System Pages instead!
    External.mergeUnique(
      settings.general,
      {
        showFilter: false,
        showSearch: false,
        showVariationsFilter: false,
        showSku: false,
        showBuyButtonInLists: false,
        showLensZoom: false,
        cartLinkType: "icontext",
        layoutType: "boxed-layout",
        productsPerRow: "6",
        discountBadgeType: "text",
        defaultSortType: "new",
        listLayout: "text-center",
        productLayout: "image-left",
        quickView: true,
        quickCart: true,
        hideUnavailableVariations: false,
        shareSum: 7,
        showRelatedProducts: false,
        relatedProductsSettings: {
          maxItemsCount: 10,
          requireItems: false
        },
        imageSize: 75,
        imageSizeType: "",
        quickCartView: "full-height"
      },
      true
    );

    dispatch("load");
  });
</script>

{#if settings}
  <div class="account-settings store-products">
    <div class="inner-wrapper member-info-wrapper">
      <div class="top-background-wrapper wide-top-background">
        <div class="top-background" style="max-width:1150px;">
          <div class="text-wrapper flex align-center space-between" data-role="contact-name">
            <div class="flex align-center">
              <h1 class="members-title f-left">{M.STORE_LAYOUT_STYLING}</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="content-wrapper" style="max-width: 1150px;">
        <div class="sections-wrapper profile-inner-wrapper" style="margin-bottom: 80px;">
          <div class="col20 f-left product-options-list mb-55 store-layout-stylingw-rapper">
            <div class="box-shadow half-section-global f-left t-center bg-white padding-45">
              <img src={resource("/images/store-layouts/l1.png")} class="f-left col20" />
              <h2 class="col20 f-left mt-25 t-center roboto f-26">{M.STORE_PRODUCT_PAGE_LAYOUT}</h2>
              <span class="col20 f-left mt-10 t-center light-gray-text">{M.STORE_PRODUCT_PAGE_LAYOUT_DESC}</span>
              <div class="col20 f-left t-center mt-15">
                <a rel="tab" href="/me/website/system/product" class="middle-button f-none inline-block blue">{M.STYLE_NOW}</a>
              </div>
            </div>

            <div class="box-shadow half-section-global f-right t-center bg-white padding-45">
              <img src={resource("/images/store-layouts/l2.png")} class="f-left col20" />
              <h2 class="col20 f-left mt-25 t-center roboto f-26">{M.STORE_LIST_PAGE_PRODUCT_LAYOUT}</h2>
              <span class="col20 f-left mt-10 t-center light-gray-text">{M.STORE_LIST_PAGE_PRODUCT_LAYOUT_DESC}</span>
              <div class="col20 f-left t-center mt-15">
                <a rel="tab" href="/me/website/system/products" class="middle-button f-none inline-block blue">{M.STYLE_NOW}</a>
              </div>
            </div>

            <div class="box-shadow half-section-global f-left t-center bg-white padding-45 mt-25">
              <img src={resource("/images/store-layouts/l3.png")} class="f-left col20" />
              <h2 class="col20 f-left mt-25 t-center roboto f-26">{M.CART_PAGE}</h2>
              <span class="col20 f-left mt-10 t-center light-gray-text">{M.CART_PAGE_DESC}</span>
              <div class="col20 f-left t-center mt-15">
                <a rel="tab" href="/me/website/system/cart" class="middle-button f-none inline-block blue">{M.STYLE_NOW}</a>
              </div>
            </div>

            <div class="box-shadow half-section-global f-right t-center bg-white padding-45 mt-25">
              <img src={resource("/images/store-layouts/l4.png")} class="f-left col20" />
              <h2 class="col20 f-left mt-25 t-center roboto f-26">{M.CHECKOUT_PAGE}</h2>
              <span class="col20 f-left mt-10 t-center light-gray-text">{M.CHECKOUT_PAGE_DESC}</span>
              <div class="col20 f-left t-center mt-15">
                <a rel="tab" href="/me/website/system/checkout" class="middle-button f-none inline-block blue">{M.STYLE_NOW}</a>
              </div>
            </div>

            <div class="box-shadow half-section-global f-left t-center bg-white padding-45 mt-25">
              <img src={resource("/images/store-layouts/l5.png")} class="f-left col20" />
              <h2 class="col20 f-left mt-25 t-center roboto f-26">{M.CART_QUICK_VIEW}</h2>
              <span class="col20 f-left mt-10 t-center light-gray-text">{M.CART_QUICK_VIEW_DESC}</span>
              <div class="col20 f-left mt-15">
                <div class="onoffswitch onoffswitch-small" style="margin: 0 auto;">
                  <input type="checkbox" class="onoffswitch-checkbox modify" id="quickCart" name="quickCart" bind:checked={settings.general.quickCart} on:change={setChanged} />
                  <label class="onoffswitch-label" for="quickCart">
                    <span class="onoffswitch-inner" />
                    <span class="onoffswitch-switch" />
                  </label>
                </div>
              </div>
              <div class="col20 f-left t-center mt-15" class:none={!settings.general.quickCart}>
                <span>{M.QUICK_VIEW_STYLE}</span>
                <select bind:value={settings.general.quickCartView} on:change={setChanged}>
                  <option value="compact">{M.QUICK_VIEW_STYLE_1}</option>
                  <option value="full-height">{M.QUICK_VIEW_STYLE_2}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      {#if changed}
        <div class="flex align-center justify-center floating-lane floating-lane-store floating-lane-product flex-none">
          <a class="middle-button blue flex-none" on:click={() => save(false)}>{M.SAVE_CHANGES}</a>
          <a class="text-button f-none inline-block ml-10" on:click={discardChanges}>{M.DISCARD_CHANGES_REFRESH}</a>
        </div>
      {/if}
    </div>
  </div>
{/if}
